/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import ActionsPopoverCallback from '../../../shared/state/actions-popover-callback';
import ActionsPopoverLink from '../../../shared/state/actions-popover-link';
import {downloadSmartForm} from '../../../shared/services/download-smart-form';
import {hasAccess} from '../../../shared/services/security';

const createLink = (label, route) =>
    new ActionsPopoverLink({
        label,
        route
    });

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

const displayProduct = values => {

    downloadSmartForm('PRODDETAIL', values.objectId);

};

export const getProductActions = (context, product, createClaimCallback, isSapUp = true) => {

    const security = context.security;
    const actionList = [];

    if (isSapUp && hasAccess(security, 'PRT', 'PRT_STATUS_CHANGE')) {

        actionList.push(createLink('UPDATE_MACHINE_STATUS', `/products/status-change-request/${product.pin}`));

    }

    if (hasAccess(security, 'PRT', 'PRT_DEALER_TRANSFER')) {

        actionList.push(createLink('CHANGE_RESPONSIBLE_DEALER', `/products/new-transfer/${product.pin}`));

    }

    if (isSapUp) {

        actionList.push(createLink('VIEW_OPEN_PIPS', `/pips/search?by=PIN&q=${encodeURIComponent(product.pin)}`));

    }

    if (isSapUp && hasAccess(security, 'CLAIM', 'CLM_CLAIM_CREATE')) {

        actionList.push(createCallBack('CREATE_CLAIM', createClaimCallback.bind(null, true)));

    }

    if (isSapUp) {

        actionList.push(createCallBack('PRINT_TO_PDF', displayProduct, {
            objectId: product.pin
        }));

    }

    return actionList;

};



// WEBPACK FOOTER //
// ./src/product/shared/services/product-actions.js